import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HistoryEntry} from '../model/model';
import {HistoryRepository} from '../repositories/history.repository';

@Injectable()
export class HistoryService {

  constructor(private historyRepository: HistoryRepository) { }

  public getHistory(): Observable<Array<HistoryEntry>> {
    return this.historyRepository.getHistory();
  }

}
